export const defaultScopeId = "v3.maintenance.data";

export const BACKUP_REQUESTED = "DATA/BACKUP_REQUESTED";
export const BACKUP_SUCCEEDED = "DATA/BACKUP_SUCCEEDED";
export const BACKUP_FAILED = "DATA/BACKUP_FAILED";
export const RESTORE_REQUESTED = "DATA/RESTORE_REQUESTED";
export const RESTORE_SUCCEEDED = "DATA/RESTORE_SUCCEEDED";
export const RESTORE_FAILED = "DATA/RESTORE_FAILED";
export const RESET_REQUESTED = "DATA/RESET_REQUESTED";
export const RESET_SUCCEEDED = "DATA/RESET_SUCCEEDED";
export const RESET_FAILED = "DATA/RESET_FAILED";

// eslint-disable-next-line max-statements
export default (state = {
    errors: [],
    loading: false,
    loggedIn: false,
}, { type, data }) => {
    switch (type) {
    case BACKUP_REQUESTED: {
        state.loading = true;
        return state;
    }
    case BACKUP_SUCCEEDED: {
        state.loggedIn = true;
        state.loading = false;
        return state;
    }
    case BACKUP_FAILED: {
        state.loggedIn = false;
        state.loading = false;
        state.errors.push(data);
        return state;
    }
    case RESTORE_REQUESTED: {
        state.loading = true;
        return state;
    }
    case RESTORE_SUCCEEDED: {
        state.loggedIn = false;
        state.loading = false;
        return state;
    }
    case RESTORE_FAILED: {
        state.loading = false;
        state.errors.push(data);
        return state;
    }
    case RESET_REQUESTED: {
        state.loading = true;
        return state;
    }
    case RESET_SUCCEEDED: {
        state.loggedIn = false;
        state.loading = false;
        return state;
    }
    case RESET_FAILED: {
        state.loading = false;
        state.errors.push(data);
        return state;
    }
    default: return state;
    }
};


export const backupRequested = data => ({ type: BACKUP_REQUESTED, data });
export const backupSucceeded = data => ({ type: BACKUP_SUCCEEDED, data });
export const backupFailed = data => ({ type: BACKUP_FAILED, data });
export const restoreRequested = (data, resolve, reject ) => ({ type: RESTORE_REQUESTED, data, resolve, reject  });
export const restoreSucceeded = data => ({ type: RESTORE_SUCCEEDED, data });
export const restoreFailed = data => ({ type: RESTORE_FAILED, data });
export const resetRequested = (data, resolve, reject ) => ({ type: RESET_REQUESTED, data, resolve, reject  });
export const resetSucceeded = data => ({ type: RESET_SUCCEEDED, data });
export const resetFailed = data => ({ type: RESET_FAILED, data });
